module.exports = __webpack_public_path__ + "static/media/add_cart.e9d986bf.png";